<template>
  <!-- 260611 typeC: Figma 센터 모달 — 제목+✕ / 구분선 / 본문 / 초록 확인 (Frame 1000005865) -->
  <div class="mgm-dim" @click.self="close">
    <div class="mgm" role="dialog" aria-labelledby="mgm-title">
      <div class="mgm__head">
        <h1 id="mgm-title">이벤트 알림권 사용 방법</h1>
        <button type="button" class="mgm__close" aria-label="닫기" @click="close">
          <svg viewBox="0 0 20 20" fill="none" stroke="#000" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">
            <path d="M5 5l10 10M15 5L5 15" />
          </svg>
        </button>
      </div>
      <div class="mgm__divider" aria-hidden="true"></div>
      <p class="mgm__body">
        기업은 자신만의 독창적인 마케팅을 빠르고 쉽게 홍보할 수 있습니다.
        동시에 ‘좋아요’를 한 고객만을 대상으로 특별한 이벤트와 혜택을
        푸시 알림으로 직접 전달할 수 있습니다.
      </p>
      <button type="button" class="mgm__confirm" @click="close">확인</button>
    </div>
  </div>
</template>
<script setup>
const emits = defineEmits(['close']);
// 260611: 기존 setTimeout(100) 제거 — 이유 불명 카피 패턴(CLAUDE.md 안티패턴 2번)
const close = () => emits('close');
</script>

<style scoped>
.mgm-dim {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.mgm {
  width: 100%;
  max-width: 343px;
  background: #fff;
  border-radius: 14px;
  padding: 30px 20px;
  box-sizing: border-box;
}
.mgm__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.mgm__head h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #000;
  line-height: 1.3;
}
.mgm__close {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.mgm__close svg {
  width: 100%;
  height: 100%;
  display: block;
}
.mgm__divider {
  height: 1px;
  background: #cacaca;
  margin: 14px 0;
}
.mgm__body {
  margin: 0 0 30px;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.03em;
  color: #000;
  word-break: keep-all;
}
.mgm__confirm {
  width: 100%;
  min-height: 50px;
  background: #2f6df6;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.mgm__confirm:active {
  background: #1c35a6;
}
</style>
